import { render, staticRenderFns } from "./SelectTier.vue?vue&type=template&id=4cb17ec7"
import script from "./SelectTier.vue?vue&type=script&lang=js"
export * from "./SelectTier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports